import {Address} from "../../address/model/Address";
import {Brand} from "../../brand_service/model/Brand";

export class Branch {
    id?: number;
    branchName?: string;
    brandName?: string;
    address?: Address = new Address();
}

export class BranchWithAssignedBrand extends Branch {
    assignedBrand?: Brand;
}